// extracted by mini-css-extract-plugin
export var billingAddress = "_r3-f";
export var contactInfo = "_r3-c";
export var customerInfoContainer = "_r3-b";
export var customerInfoRow = "_r3-9";
export var customerInfoSection = "_r3-a";
export var fullWidthDividerMobile = "_r3-g";
export var imageContainer = "_r3-1";
export var paymentMethod = "_r3-d";
export var priceText = "_r3-6";
export var priceTextMobile = "_r3-7";
export var product = "_r3-0";
export var productImage = "_r3-2";
export var productInfo = "_r3-4";
export var productTitle = "_r3-8";
export var quantityBadge = "_r3-3";
export var quantityText = "_r3-5";
export var shippingAddress = "_r3-e";